import { fetcher } from 'services/helpers/responseHandler'

const save = async name => await fetcher.post('audiences/save', { name })

const update = async ({
  id,
  name,
  rateCodes,
  lastUseFrom,
  lastUseTo,
  membership,
  bookingSource,
  nightlyRate,
  minStays,
  maxStays,
  distance,
  reviewRating,
  states,
  futureStayDateFrom,
  futureStayDateTo,
  isForFutureGuests
}) =>
  await fetcher.post('audiences/save', {
    id,
    name,
    rateCodes,
    lastUseFrom,
    membership,
    bookingSource,
    nightlyRate,
    lastUseTo,
    minStays,
    maxStays,
    distance,
    reviewRating,
    states,
    futureStayDateTo,
    futureStayDateFrom,
    isForFutureGuests
  })

const get = async id => await fetcher.get(`audiences/${id}`)

const del = async id => await fetcher.del(`audiences/${id}`)

const getList = async (skip = 0, take = 100) =>
  await fetcher.post('audiences/list', { skip, take })

const getRateCodesByTracking = async ({
  trackingCode,
  rateCodeBeginWith,
  returnAllRateCodes = false
}) =>
  await fetcher.get(`transactionsHotel/tracking-codes/load`, {
    trackingCode,
    rateCodeBeginWith,
    returnAllRateCodes
  })

const audienceApi = {
  getRateCodesByTracking,
  save,
  update,
  get,
  del,
  getList
}

export default audienceApi
